/**
 * Telemetry facade.
 *
 * Default adapter is null (no-op) — Phase 13 calls `setTelemetryAdapter`
 * with an AppInsights-backed implementation when the connection string env
 * var is set. Components and services only ever import `telemetry` from
 * here; they never reach for the AppInsights SDK directly.
 */
export interface TelemetryAdapter {
  trackEvent(name: string, properties?: Record<string, unknown>): void;
  trackException(error: Error, properties?: Record<string, unknown>): void;
  trackPageView(name: string, properties?: Record<string, unknown>): void;
}

let adapter: TelemetryAdapter | null = null;

export const setTelemetryAdapter = (next: TelemetryAdapter | null): void => {
  adapter = next;
};

export const telemetry: TelemetryAdapter = {
  trackEvent: (name, properties) => adapter?.trackEvent(name, properties),
  trackException: (error, properties) => adapter?.trackException(error, properties),
  trackPageView: (name, properties) => adapter?.trackPageView(name, properties),
};
